<template src="./register.html">
</template>

<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import Loader from '@/components/misc/Loader'
  import Vuelidate from 'vuelidate'
  import { required, email } from 'vuelidate/lib/validators'
  import { validationMixin } from '@/mixins/validation'
  import Autocomplete from '@/components/misc/autocomplete/Autocomplete'
  import ContextHeader from '@/components/misc/context-header/ContextHeader'

  Vue.use(Vuelidate)

  export default {
    name: 'register',
    mixins: [validationMixin],
    components: {
      Loader,
      Autocomplete,
      ContextHeader
    },
    data () {
      return {
        load: false,
        registrationAllowed: Vue.$config.registration_allowed,
        register: {
          isPublicEntity: false,
          budgetNumber: '',
          taxIdNumber: '',
          companyNumber: '',
          parentInstitutionTaxIdNumber: '',
          parentInstitutionCompanyNumber: '',
          name: '',
          address: '',
          phoneNumber: '',
          email: '',
          treasuryBranch: '',
          adminName: '',
          adminIdentityNumber: '',
          adminEmail: '',
          adminPhoneNumber: '',
          registrationToken: null
        },
        registrationToExport: null,
        registrationConfirmation: null,
        pplCompanyNumber: '',
        treasuryBranchUrl: '',
        autoCompleteUrl_branches: Vue.$apiConfig.treasuryBranchesGet,
        ouLink: Vue.$config.help_root + '/_files/UTOJ.xls',
        registrationToken: null
      }
    },
    created () {
      this.treasuryBranchUrl = Vue.http.options.root + '/' + Vue.$apiConfig.treasuryBranchesGet
    },
    methods: {
      validateBeforeSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$t('errors.someErrorsOccuredCheckListBelow'),
            errors: this.getValidationErrors('register')
          })

          this.$nextTick(function () {
            document.body.scrollTop = 0
          })
          return
        }
        this.submit()
      },
      submit () {
        this.load = true
        this.logConsole(this.register)
        window.scrollTo(0, 0)

        let tempRegistration = JSON.parse(JSON.stringify(this.register))
        Vue.delete(tempRegistration, 'invoiceLimit')

        this.$http.post(Vue.$apiConfig.registerEntity, tempRegistration)
          .then((response) => {
            this.load = false
            this.$v.$reset()
            this.registrationToExport = Object.assign({}, this.register)
            this.register.isPublicEntity = false
            this.register.budgetNumber = ''
            this.register.taxIdNumber = ''
            this.register.companyNumber = ''
            this.register.parentInstitutionTaxIdNumber = ''
            this.register.parentInstitutionCompanyNumber = ''
            this.register.name = ''
            this.register.address = ''
            this.register.phoneNumber = ''
            this.register.email = ''
            this.register.treasuryBranch = ''
            this.register.adminName = ''
            this.register.adminIdentityNumber = ''
            this.register.adminEmail = ''
            this.register.adminPhoneNumber = ''
            this.registrationConfirmation = response.data.payload.registrationConfirmation
            this.$refs.registerConfirmationModal.show()
            setTimeout(() => {
              this.$refs.registerForm.reset()
              this.$refs.treasuryBranchAutocomplete.resetContents()
              this.registrationToken = this.register.registrationToken = null
            }, 1)
          }, (error) => {
            this.logConsole(error)
            this.formatErrorResponse(error, 'register.registrationLimitExceeded')
            this.load = false
          })
      },
      autocompleteErrorClass () {
        return this.$v.register.treasuryBranch.$error ? 'error' : null
      },
      printRegistration () {
        this.exportRegistration(this.registrationToExport, this.$refs.imgToExport)
      },
      sendRegistrationToken () {
        this.load = true

        let registrationToken = {
          registrationToken: this.registrationToken.trim()
        }
        this.$http.post(Vue.$apiConfig.registrationTokenPost, registrationToken)
          .then((response) => {
            this.load = false
            this.registrationToExport = null
            let registration = response.data.payload

            this.register = registration
            this.register.registrationToken = this.registrationToken
            this.register.treasuryBranch = registration.treasuryBranch.toString()
            this.$refs.treasuryBranchAutocomplete.setContents(registration.treasuryBranch.toString())
            if (registration.budgetCompanyNumber && registration.budgetCompanyNumber.length > 0) {
              this.register.budgetNumber = registration.companyNumber
              this.register.companyNumber = registration.budgetCompanyNumber
            } else {
              this.register.budgetNumber = ''
              this.register.companyNumber = registration.companyNumber
            }
            this.$refs.editRegistrationModalRef.hide()
          }, (error) => {
            this.logConsole(error)
            this.formatErrorResponse(error, 'register.registrationLimitExceeded')
            this.$refs.editRegistrationModalRef.hide()
            this.load = false
          })
      },
      closeConfirmationModal () {
        this.$refs.registerConfirmationModal.hide()
      },
      legalInformationEditable () {
        return this.register.registrationToken && this.register.registrationToken.length > 0
      }
    },
    validations () {
      let rules = {}

      rules.parentInstitutionTaxIdNumber = {}
      rules.parentInstitutionCompanyNumber = {}

      Object.assign(rules, {
        companyNumber: {
          required
        },
        taxIdNumber: {
          required
        },
        name: {
          required
        },
        address: {
          required
        },
        phoneNumber: {
          required
        },
        email: {
          required, email
        },
        treasuryBranch: {
          required
        },
        adminName: {
          required
        },
        adminIdentityNumber: {
          required
        },
        adminEmail: {
          required, email
        },
        adminPhoneNumber: {
          required
        }
      })

      return {
        register: rules
      }
    }
  }

</script>

<style lang="scss" scoped>

    h4 {
        margin-top: 20px;
        margin-bottom: 20px;
    }

</style>



// WEBPACK FOOTER //
// Register.vue?cbb3dba0